const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized || !GA4_ID || typeof window === 'undefined') return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, { send_page_view: false });
}

export function trackPageView(path, title) {
  if (!GA4_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
}

export function trackReportView({ activist, reportTitle, targetCompany, ticker }) {
  if (!GA4_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'report_view', {
    activist,
    report_title: reportTitle,
    target_company: targetCompany,
    ticker,
  });
}

export function trackProfileView({ activistName, totalReports }) {
  if (!GA4_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'profile_view', {
    activist_name: activistName,
    total_reports: totalReports,
  });
}

export function trackAlertSignup({ source, subject }) {
  if (!GA4_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', 'alert_signup', {
    source,
    subject,
  });
}

export function isAnalyticsEnabled() {
  return Boolean(GA4_ID);
}
